<template>
  <div class="v-date-picker">
    <ValidationProvider
      :ref="validationProviderRef"
      :mode="veeValidateInteractionMode"
      :rules="rules"
      :vid="validationProviderRef"
      :name="label"
    >
      <v-dialog
        ref="menu"
        v-model="isMenuOpen"
        :closeOnContentClick="false"
        persistent
        width="340px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :id="validationProviderRef"
            v-model="time"
            :label="label"
            :color="color"
            :disabled="disabled"
            readonly
            prependInnerIcon="event"
            :outlined="!!isOutlined"
            v-bind="$attrs"
            v-on="viewonly ? null : on"
          />
        </template>

        <v-card>
          <div>
            <v-row class="m-0">
              <v-col
                cols="6"
                class="p-0"
              >
                <v-btn
                  tile
                  minWidth="100%"
                  color="primary"
                  :elevation="0"
                >
                  <v-icon>
                    mdi-clock
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-card-title class="justify-center">
              {{ timeSelected }}
            </v-card-title>
            <v-time-picker
              v-model="time"
              :format="timePickerFormat[$store.getters.lang]"
              :disabled="disabled"
              noTitle
            >
              <v-spacer />
              <v-btn
                text
                color="primary"
                @click="onClickCancel"
              >
                {{ $t('forms.btn.cancel') }}
              </v-btn>
              <v-btn
                text
                :disabled="!time"
                color="primary"
                @click="onClickSave"
              >
                {{ $t('forms.btn.confirm') }}
              </v-btn>
            </v-time-picker>
          </div>
        </v-card>
      </v-dialog>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { ValidationProvider } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import _timePickerFormat from '@/constants/timePickerFormat';

export default {
    components: {
        ValidationProvider,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: null,
        },
        rules: {
            type: Object,
            default: () => ({ required: false }),
        },
        color: {
            type: String,
            default: '#003876',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        format: {
            type: String,
            default: 'L LT',
            validation: value => ['24hr', 'L LT'].indexOf(value) !== -1,
        },
        viewonly: {
            type: Boolean,
            default: false,
        },
        isOutlined: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            time: null,
            isCalendar: true,
            isMenuOpen: false,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
        timeSelected() {
            return this.time || '';
        },
        timePickerFormat() {
            return _timePickerFormat;
        },
    },
    watch: {
        value: {
            handler() {
                if (!this.value) {
                    return;
                }
                this.time = this.value;
            },
            immediate: true,
        },
    },
    methods: {
        onClickCancel() {
            this.reset();
        },
        onClickSave() {
            this.$refs.menu.save();
            this.$emit('input', this.time);
            this.reset();
        },
        reset() {
            this.isMenuOpen = false;
            this.time = null;
        },
    },
};

</script>

  <style lang="scss" scoped>
    .v-date-picker {
      height: 53px !important;
    }
  </style>
